import { trackKnownAnalyticsEvent } from "../analyticsClient";
import {
  buildReadingSessionEndParams,
  buildReadingSessionStartParams,
  ReadingSessionEndParamsInput,
  ReadingSessionStartParamsInput,
} from "../params/reading";

export function trackReadingSessionStart(
  params: ReadingSessionStartParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "reading_session_start",
    buildReadingSessionStartParams(params),
  );
}

export function trackReadingSessionEnd(params: ReadingSessionEndParamsInput): void {
  trackKnownAnalyticsEvent("reading_session_end", buildReadingSessionEndParams(params));
}
